import React from 'react';
import { Navigate } from 'react-router-dom';

interface props {
  path: string;
}

const Redirect: React.FC<props> = ({ path }) => {
  const linkTarget = {
    pathname: path,
    key: new Date(),
    state: {
      applied: true
    }
  };

  return (
    <>
      <Navigate to={linkTarget} replace={true} />
    </>
  );
};

export default Redirect;
